// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bf3d0db9","952":"c8cbd1b4"}[chunkId] + ".chunk.js";
};